<template>
  <div v-if="!disableAddonModal">
  <head>
    <link rel="stylesheet" :href="css">
  </head>
  <div class="black-overlay"></div>
  <div class="modal modal--postfreegame" id="welcome_modal">
    <div class="modal__content">
    <div class="game_bg pre_post">
      <div class="game_box">
        <span v-if="puzzleGameCss === 'puzzle'">
        <div class="title">{{ getTranslations.home_addongame_puzzle_celebrate }}</div>
        <div class="subtitle">{{ getTranslations.home_addongame_puzzle_earned }}<br> {{ getTranslations.home_addongame_puzzle_bonus_game }}</div>
        </span>
        <span v-else>
        <div class="subtitle">{{ getTranslations.home_addongame_puzzle_earned }}</div>
        <div class="title">{{ getTranslations.home_addongame_puzzle_celebrate }}</div>
        <p class="puzz_pre_phrase">{{ getTranslations.home_addongame_puzzle_click }}</p>
        </span>
        <img :src="'static/mini_games/puzzle_game/assets/'+img+'.png'" alt="game background">
        <p>{{ getTranslations.home_addongame_puzzle_have }} {{ timerForPuzzleGame }} {{ getTranslations.home_addongame_solve_puzzle }}</p>
        <p>{{ getTranslations.home_addongame_puzzle_luck }}</p>
        <button type="button" class="btn" @click="goToAddOnGame">{{ getTranslations.home_addongame_puzzle_play }}</button>
      </div>
    </div>
    </div>
  </div>
  <div class="modal-overlay" @click="close()"></div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'pre-game-add-on-puzzle',
  data() {
    return {
      disableAddonModal: false,
      css: '',
      img: '',
    };
  },
  created() {
    this.setActiveAddOnMiniGame(true);
    sessionStorage.setItem('time', this.timerForPuzzleGame);
    this.css = localStorage.getItem('locale') === ('AR' || 'KU') ?
      `../../../../../static/mini_games/puzzle_game/${this.puzzleGameCss}_AR.css` :
      `../../../../../static/mini_games/puzzle_game/${this.puzzleGameCss}.css`;
    this.img = this.puzzleGameCss === 'puzzle' ? 'bg_puzzle' : 'bg_puzzle_ramadan';
    this.showHideModal();
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage);
  },
  methods: {
    ...mapMutations('profile', [
      'clearPuzzleGame',
    ]),
    ...mapMutations('common', [
      'setActiveAddOnMiniGame',
    ]),
    showHideModal() {
      this.$nextTick(() => {
        /* eslint-disable */
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          console.log('user has not leveled up, going to home page');
          /* eslint-disable */
          this.currentModal = null;
        });
      });
    },
    close() {
      this.clearPuzzleGame();
      this.setActiveAddOnMiniGame(false);
    },
    goToAddOnGame() {
      this.disableAddonModal = true;
      this.$router.push({ name: 'addOnGamePuzzle', params: { fromPreGame: 'true' } });
    },
  },
  computed: {
    ...mapState('common', [
      'addOnMode',
      'activeAddOnMiniGame',
      'userDetails',
      'multiOperatorInfo',
      'timerForPuzzleGame',
      'puzzleGameCss',
    ]),
    ...mapState('game', [
      'homePlayerTotalEarnedPoints',
      'gameID',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/game/addongamepuzzle/PreGameAddOnPuzzle.vue